import { Civil3dFeatureType } from '../constants/civil3d-feature-type';
import { ArcgisCivil3dPropertyMappingApiModel } from './arcgis-civil3d-property-mapping.model';
import { ArcgisCivil3dSettingApiModel } from './arcgis-civil3d-setting.model';
import { AutodeskLayerApiModel } from './autodesk-layer.model';
import { LineStyleApiModel } from './line-style.model';

export type ArcgisCivil3dFeatureLineSettingApiModel = ArcgisCivil3dSettingApiModel & {
  civil3dFeatureType: string;
  lineStyle: { id: number } | null;
  autodeskLayer: { id: number } | null;
};

export type WithCivil3dFeatureType = ArcgisCivil3dFeatureLineSettingApiModel & {
  civil3dFeatureType: Civil3dFeatureType;
};

export type WithLineStyle = ArcgisCivil3dFeatureLineSettingApiModel & {
  lineStyle: LineStyleApiModel | null;
};

export type WithAutodeskLayer = ArcgisCivil3dFeatureLineSettingApiModel & {
  autodeskLayer: (Pick<AutodeskLayerApiModel, 'id'> & { name: string }) | null;
};

export type WithPropertyMappings = ArcgisCivil3dFeatureLineSettingApiModel & {
  propertyMappings: ArcgisCivil3dPropertyMappingApiModel[];
};

export enum ArcgisCivil3dFeatureLineSettingRelationship {
  CONFIGURATION = 'CONFIGURATION',
  ARCGIS_FEATURE_CLASS = 'ARCGIS_FEATURE_CLASS',
  LINE_STYLE = 'LINE_STYLE',
  AUTODESK_LAYER = 'AUTODESK_LAYER',
  PROPERTY_MAPPINGS = 'PROPERTY_MAPPINGS',
}
